module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAYAAACmPacqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARZJREFUeNrsluENgjAQhYsTdAPZAEboCIzACLoBG+AGuIEj1A1wA3UCdAJtk9Y8T8oP0CuJvOQFaJre16PtVYgZKQm0S+P8x7FPxrehDhaiMX4wuXExP2QzcWYE8bYxUwrTQgdtXISoJ0q6sTXEa7FDSVLHJVwSpW/UkDLJCCNhaWjf2LmGOsKOrn12VkBodY8A84q5mtOht8AsMAvMt2Eu7plFYMgIw1uNyBlB8r6aqEgFTRlAUnJTUAmpERv43htfyQBHZ5xZMQJkjVXaaGe8HSrpfa6gr4ICO/W2F5QNcggEqnruP2PcuRhqzP9FGJq9knv74YzwXcU4j2iaW+YjIAijma+mQZhGzEBRFmpIhfg3PQUYAMYatIsukDHhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/EventDetail_MessageIcon.png
// module id = XIHu
// module chunks = 1